import { Component, inject, ViewChild, type OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
  type Event,
} from '@angular/router'
import { TitleService } from '@core/services/title.service'
import { NgProgressbar, NgProgressRef } from 'ngx-progressbar'
import { CommonDataStorage } from './common/commonDataStore'
import { Store } from '@ngrx/store'
import { changetheme } from './store/layout/layout-action'
import { environment } from '@/environments/environment'
import { getLayoutColor } from './store/layout/layout-selector'

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, NgProgressbar],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  @ViewChild(NgProgressRef) progressBar!: NgProgressRef

  private titleService = inject(TitleService)
  private router = inject(Router)
  public store = inject(Store)
  public commonData = inject(CommonDataStorage)
  constructor() {
    this.router.events.subscribe((event: Event) => {
      this.checkRouteChange(event)
    })
  }

  ngOnInit(): void {
    const savedTheme = localStorage.getItem('theme') || 'light';
    document.documentElement.setAttribute('data-bs-theme', savedTheme);
    this.store.dispatch(changetheme({ color: savedTheme }));
    this.titleService.init()
    if (localStorage.getItem("token")) {
      this.commonData.getAllData();
      this.commonData.permission();
    }

    // Update favicon on theme change
    this.store.select(getLayoutColor).subscribe(color => {
      let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = color === 'dark' ? './assets/images/krigo_dark_logo.png' : './assets/images/krigo_light_logo.png';
    });
  }

  // show Loader when route change
  checkRouteChange(routerEvent: Event) {
    if (routerEvent instanceof NavigationStart) {
      this.progressBar.start()
    }
    if (
      routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError
    ) {
      setTimeout(() => {
        this.progressBar.complete()
      }, 200)
    }
  }
}
